import React from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap/breadcrumb';

import { Spinner } from '@admin/components/spinner';
import { useNavigate } from '@admin/hooks/use_navigate';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useAccountAddressNewQuery } from '@admin/schema';

import { AccountAddressForm } from './form';

export const New: React.FC = () => {
  useTitle('Addresses');
  const { accountID } = useParams<{ accountID: string }>();
  const navigate = useNavigate();
  const { data } = useAccountAddressNewQuery({ client, variables: { accountID } });
  if (!data) return <Spinner />;

  const onSave = (address: { id: string }) => {
    navigate(`/accounts/${accountID}/addresses/${address.id}`);
  };

  const account = data.account;

  return (
    <>
      <h1 className="page-header text-overflow">
        <Breadcrumb>
          <Breadcrumb.Item>
            <NavLink to="/accounts">Accounts</NavLink>
          </Breadcrumb.Item>{' '}
          <Breadcrumb.Item>
            <NavLink to={`/accounts/${accountID}`}>
              #{account.number} ({account.customer.name})
            </NavLink>
          </Breadcrumb.Item>{' '}
          <Breadcrumb.Item active>Addresses - New</Breadcrumb.Item>
        </Breadcrumb>
      </h1>

      <AccountAddressForm accountID={accountID} onSave={onSave} />
    </>
  );
};
